import React from 'react';
import { Link } from 'gatsby';
import menuData from '../sources/menu-data';

class Header extends React.Component {
  state = { active: false };

  headerRef = React.createRef();

  handleTriggerMenu = () => {
    const { active } = this.state;

    this.setState({ active: !active });
  };

  handleCloseMenuByClickOption = () => {
    const { active } = this.state;

    if (active) {
      this.setState({ active: false });
    }
  };

  handleCloseMenuByClickOutside = event => {
    const { active } = this.state;
    const { current: headerElement } = this.headerRef;

    if (active && !headerElement.contains(event.target)) {
      this.setState({ active: false });
    }
  };

  componentDidMount() {
    document.addEventListener('click', this.handleCloseMenuByClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleCloseMenuByClickOutside);
  }
  
  render() {
    const { active } = this.state;
    let triggerButtonClass = "glyph bars";
    let showNavBarClass = "menu menu-closed";

    if (active) {
      triggerButtonClass = "glyph close";
      showNavBarClass = "menu menu-open";
    }

    return (
      <header ref={this.headerRef}>
        <section className="main-header">
          <div className="container">
            <div className="row">  
              <div className="col-xs-10">
                <Link to="/">
                  <img src={require('../images/logo-n3twork.svg')?.default} alt="logo" className="logo"/>
                </Link>
              </div>
              <div className="col-xs-2">
                <button
                  className={triggerButtonClass}
                  onClick={this.handleTriggerMenu}
                />
              </div>
            </div>
          </div>
        </section>  
        <section className={showNavBarClass}>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <nav>
                  <ul className="primary-nav">
                  {menuData.map(menu => {
                    let route = `${menu.page}/${menu.slide}`;

                    if (menu.page === '/' && menu.slide === undefined) {
                      route = menu.page;
                    }

                    // This could be refactored to loop through
                    let subRoute1 = `${menu.page}/${menu.subSlide1}`;
                    let subRoute2 = `${menu.page}/${menu.subSlide2}`;
                    let subRoute3 = `${menu.page}/${menu.subSlide3}`;
                    let subRoute4 = `${menu.page}/${menu.subSlide4}`;
                    let subRoute5 = `${menu.page}/${menu.subSlide5}`;
                    let subRoute6 = `${menu.page}/${menu.subSlide6}`;
                    let subRoute7 = `${menu.page}/${menu.subSlide7}`;
                    
                    return (
                      <li key={route}>
                        <Link to={route} onClick={this.handleCloseMenuByClickOption}>
                          {menu.label}
                        </Link>
                        <ul className="sub-nav">
                          <li key={subRoute1}>
                            <Link to={subRoute1} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel1}
                            </Link>
                          </li>
                          <li key={subRoute2}>
                            <Link to={subRoute2} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel2}
                            </Link>
                          </li>
                          <li key={subRoute3}>
                            <Link to={subRoute3} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel3}
                            </Link>
                          </li>
                          <li key={subRoute4}>
                            <Link to={subRoute4} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel4}
                            </Link>
                          </li>
                          <li key={subRoute5}>
                            <Link to={subRoute5} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel5}
                            </Link>
                          </li>
                          <li key={subRoute6}>
                            <Link to={subRoute6} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel6}
                            </Link>
                          </li>
                          <li key={subRoute7}>
                            <Link to={subRoute7} onClick={this.handleCloseMenuByClickOption}>
                            {menu.subLabel7}
                            </Link>
                          </li>
                        </ul>
                      </li>
                    );
                    })}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </section>
      </header> 
    );
  }
}

export default Header;
